module.exports = __webpack_public_path__ + "static/media/video-placeholder.c856bde5.png";